import React, { ReactElement, useMemo } from 'react';
import { FieldArray } from 'formik';
import AddGuestButton from '../AddGuestButton';
import GuestName from '../GuestName';
import EventSelector from '../EventSelector';
import { Person, Event, FocusOn } from '../interfaces';
import { createEmptyPerson } from '../helpers';
import styles from './styles.scss';

interface GuestListProps {
  people: Person[];
  leaderIndex: number;
  events: Event[];
  selectedEvent?: Event;
  focusOn: FocusOn;
}

const GuestList: React.FC<GuestListProps> = ({ people, leaderIndex, events, selectedEvent, focusOn }) => {
  const memoizedPeople = useMemo(() => people, [people]);
  const guestListContent = ({ push, replace, remove }: { push: any; replace: any; remove: any }): ReactElement => {
    const leaderFirstName = memoizedPeople[leaderIndex].firstName;

    return (
      <div className={styles.guestListContainer}>
        {memoizedPeople.map((person, index) => {
          const key = `people.${index}`;
          if (focusOn !== FocusOn.all && index > 0) {
            return null;
          }
          return (
            <div key={key} className={styles.container}>
              <GuestName
                person={person}
                index={index}
                leaderFirstName={leaderFirstName}
                isLeader={person.isLeader}
                replace={replace}
                remove={remove}
              />
              <EventSelector formikName={`people.${index}.invitations`} events={events} />
            </div>
          );
        })}
        {focusOn === FocusOn.all && (
          <AddGuestButton
            onClick={(): void => {
              const emptyPerson = createEmptyPerson(events, selectedEvent);
              push(emptyPerson);
            }}
          />
        )}
      </div>
    );
  };

  return <FieldArray name="people" render={guestListContent} />;
};

export default GuestList;
